module.exports = __webpack_public_path__ + "img/iconnew.ec505e96.png";